module.exports = __webpack_public_path__ + "static/media/22-en.ed77b041.svg";